/** Values shared by client and server. Game balance lives in core-sim/data. */

export const API_PREFIX = "/api/v1";

/** Client poll cadence for the sync cursor (05 §7). */
export const SYNC_POLL_MS = 15_000;
export const SYNC_POLL_MS_BACKGROUND = 60_000;

/** Minimum age gate, enforced everywhere (10 §5). */
export const MIN_AGE = 16;

/**
 * The tab bar (village screen, Sep 2026): three, not five. The target list and
 * the army planner were two tabs you had to visit in order, and Alliance was an
 * empty placeholder. "Attack" now holds both steps; Alliance returns when
 * alliances exist.
 */
export const TAB_IDS = ["village", "map", "trials", "reports"] as const;
export type TabId = (typeof TAB_IDS)[number];
